(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["commitment-content"]) return;
  try {
    
document.querySelectorAll('.nav-link').forEach(function (e) {
    e.addEventListener('click', smoothScroll)
});

function smoothScroll(e) {
    e.preventDefault();
    const link = this.getAttribute('href').replace('#', '');
    const offsetTop = document.querySelector(`[id=${link}]`).offsetTop;
    scroll({
        top: offsetTop - 55,
        behavior: 'smooth',
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordian"]) return;
  try {
    



  /* Toggle between adding and removing the "active" and "show" classes when the user clicks on one of the "Section" buttons. The "active" class is used to add a background color to the current button when its belonging panel is open. The "show" class is used to open the specific accordion panel */

  var acc = document.getElementsByClassName("accordion");

var i;



for (i = 0; i < acc.length; i++) {

  acc[i].addEventListener("click", function() {

    this.classList.toggle("active");

    var panel = this.nextElementSibling;

    if (panel.style.display === "block") {

      panel.style.display = "none";

    } else {

      panel.style.display = "block";

    }

  });

}




  } catch(e) { console.error(e); }
})();
})();
